import { GET_OFFERS_INIT, GET_OFFERS_FAILURE, GET_OFFERS_SUCCESS } from '@store/action-types/offers';
import client from '@api-sdk/client';
import { getUrlQueryParams } from '@shared/components/Table/utils';

const getOffersInit = () => ({ type: GET_OFFERS_INIT });
const getOffersSuccess = ({ response, activeFilters, pagination, order }) => ({
  type: GET_OFFERS_SUCCESS,
  payload: {
    items: response?.items,
    activeFilters,
    configuredFilters: response?.configuredFilters,
    configuredOrder: response?.configuredOrder,
    appliedOrder: response?.appliedOrder,
    configuredPagination: response?.pagination,
    pagination,
    order,
  },
});
const getOffersFailure = error => ({ type: GET_OFFERS_FAILURE, payload: { error } });

const getOffers = ({ activeFilters, pagination, order } = {}) => async dispatch => {
  dispatch(getOffersInit());
  const urlQueryParams = getUrlQueryParams();

  try {
    const offers = await client.getOffers({ params: activeFilters || urlQueryParams?.all });
    dispatch(
      getOffersSuccess({
        response: offers.response,
        activeFilters: activeFilters || urlQueryParams?.activeFilters,
        pagination: pagination || urlQueryParams?.pagination,
        order: order || urlQueryParams?.order,
      }),
    );
  } catch (error) {
    dispatch(getOffersFailure(error));
  }
};

export default getOffers;
